import { useEffect } from "react";
import { getFirebaseAnalytics } from "@/firebase";
import { appEnv } from "@/config/env";

export default function AnalyticsInitializer() {
  useEffect(() => {
    if (!appEnv.firebaseMeasurementId) {
      return;
    }
    void getFirebaseAnalytics();
  }, []);

  return null;
}






